export const myListPageSlug = 'my-list';
export const playerSettingsSubtitleOffText = 'Off';
export const emailRegexp =
  // case insensitive
  // eslint-disable-next-line max-len
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i;
export const underlayImageParam = ';Crop,gravity=Center,width=1920,height=1080;Blur=80';
export const primaryCredentialFormControlKey = 'email';
export const binNumberMinLength = 13;
export const binNumberMaxLength = 16;
export const gatewayInputValidationDebounceTimeInMs = 500;
export const listDebounceTimeMilliseconds = 300;
export const episodeListLayoutLocalStorageKey = 'episodeListLayoutForUsers';
export const topCarouselItemCount = 10;
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const mpxNodeCacheTtl = 5 * 60; // five mins
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const localizationCacheTtlMs = 1000 * 60 * 5; // one min
